import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ListProfiles from 'containers/Organizations/SingleOrganization/Profiles/AllProfiles/ListProfiles';

const AllProfiles = ({ history, openSingleProfile }) => {
  const { loading, meta, items } = useSelector(
    ({ profiles: { profileList } }) => profileList,
  );

  return (
    <ListProfiles
      history={history}
      items={items}
      loading={loading}
      meta={meta}
      openSingleProfile={openSingleProfile}
      all
    />
  );
};

AllProfiles.propTypes = {
  history: PropTypes.objectOf(Object).isRequired,
  openSingleProfile: PropTypes.func,
};

AllProfiles.defaultProps = {
  openSingleProfile: null,
};

export default AllProfiles;
